<template>
  <div class="footer">
    <div class="container">
      <div class="footer__offers">
        <div class="offers-row">
          <div class="offers-company offers-company--inline">
            <span>{{ $t("footer.tov-text") }}</span>
            <a :href="'mailto:' + $t('footer.email')" class="email">
              {{ $t("footer.email") }}
            </a>
          </div>
          <a
            href="https://drive.google.com/file/d/1oLHISBWndVWlr2ZU1uKxltem-Rib0dj6/view?usp=sharing"
            target="_blank"
            class="footer__link"
          >
            {{ $t("footer.public-agreement") }}
          </a>
        </div>
        <div class="offers-row">
          <div class="offers-company">{{ $t("footer.description") }}</div>
          <a
            href="https://drive.google.com/file/d/1Nx0TKdILeFmwKhSFGvFVX2ukayDU1w-0/view?usp=sharing"
            target="_blank"
            class="footer__link"
          >
            {{ $t("footer.nrcu-offer") }}
          </a>
        </div>
      </div>
      <div class="footer__images">
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_visa.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_mastercard.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_apple_pay.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_google_pay.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/xpay.svg" />
        </div>
        <!--        <div class="footer__image">-->
        <!--          <img src="~@/assets/img/icons/mtb.svg" />-->
        <!--        </div>-->
        <div class="footer__image">
          <img src="~@/assets/img/icons/portmone.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
.footer {
  margin-top: 70px;
  padding: 15px;

  .container {
    display: flex;
    align-items: center;
  }

  &__offers {
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: $black;
    margin-right: 20px;
  }

  .offers-row {
    display: grid;
    grid-template-columns: minmax(360px, 1fr) auto;
    align-items: center;
    column-gap: 24px;
  }

  .offers-company {
    color: $action;
    font-weight: 700;
  }

  .offers-company--inline {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .email {
    color: $action;
    font-weight: 400;
    text-decoration: none;
  }

  &__link {
    color: $action;

    &:hover {
      text-decoration: none;
    }
  }

  &__images {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  &__image {
    margin-right: 15px;
    height: 20px;

    &:last-child {
      margin-right: 0;
    }

    img {
      height: 100%;
    }
  }

  @media (max-width: 992px) {
    .container {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    &__offers {
      margin-right: 0;
      width: 100%;
    }

    .offers-row {
      grid-template-columns: 1fr;
      row-gap: 6px;
    }

    &__images {
      margin-left: 0;
      flex-wrap: wrap;
      gap: 10px;
    }

    &__image {
      margin-right: 0;
    }
  }
}
</style>
